import { ReactNode } from 'react';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionGateProps {
  organizationId: string;
  ability: keyof NonNullable<ReturnType<typeof usePermissions>['permissions']>;
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({ organizationId, ability, children, fallback = null }: PermissionGateProps) {
  const { permissions, loading } = usePermissions(organizationId);
  if (loading) return null;
  if (!permissions || !permissions[ability]) return <>{fallback}</>;
  return <>{children}</>;
}
